/**
 * Component that generates and applies global font-face styles.
 *
 * This component uses the `@emotion/react` library to inject global styles for custom fonts.
 * It dynamically generates the `@font-face` CSS rules based on the `fontImports` configuration.
 *
 * @returns {JSX.Element} A React component that applies global font-face styles.
 */
import React from 'react'
import {Global} from '@emotion/react'
import {getAssetUrl} from '@salesforce/pwa-kit-react-sdk/ssr/universal/utils'
import {
    delonghiFontImports,
    nutribulletFontImports,
    braunFontImports,
} from '../../theme/import/utils'
import {BRAND_KEY} from '../../brand'
import Helmet from 'react-helmet'

export const Fonts = () => {
    let fonts
    switch (BRAND_KEY) {
        case 'nutribullet':
            fonts = nutribulletFontImports
            break
        case 'delonghi':
            fonts = delonghiFontImports
            break
        case 'braun':
            fonts = braunFontImports
            break
        default:
            fonts = []
            break
    }

    const fontFaceGenerate = () => {
        var importFontString = ''

        fonts.forEach((font) => {
            font.variants.forEach((variant) => {
                const fileName = `${font.family}${variant.name}`
                const fontPath = `static/fonts/${font.folder}/${font.family}/${fileName}`
                importFontString += `
                @font-face {
                    font-family: '${font.family}';
                    src:  url(${getAssetUrl(`${fontPath}.woff2`)}) format('woff2');
                    font-display: swap;
                    font-weight: ${variant.weight};
                }
                `
            })
        })

        return importFontString
    }

    if (BRAND_KEY === 'kenwood') {
        return (
            <Helmet>
                <link rel="preconnect" href="https://fonts.googleapis.com" />
                <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin />
                <link
                    href="https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap"
                    rel="stylesheet"
                ></link>
            </Helmet>
        )
    }

    const generatedStyleForFonts = fontFaceGenerate()
    return (
        <>
            {BRAND_KEY === 'delonghi' && (
                <Helmet>
                    <link rel="preconnect" href="https://fonts.googleapis.com" />
                    <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin />
                    <link
                        href="https://fonts.googleapis.com/css2?family=Google+Sans+Flex:opsz,wght@6..144,100..900&display=swap"
                        rel="stylesheet"
                    />
                </Helmet>
            )}
            <Global styles={generatedStyleForFonts} />
        </>
    )
}
